/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel";
import "flatpickr/dist/flatpickr.css";
import "jquery-ui/themes/base/all.css";
import "jquery-bar-rating/dist/themes/fontawesome-stars-o.css";
import "intl-tel-input/build/css/intlTelInput.css";
import "babel-polyfill";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import globalFunctions from "./components/common/global-functions";

const header = require("./components/common/header");
const footer = require("./components/common/footer");
const carousel = require("./components/common/carousel");
const secondHeader = require("./components/common/second-header");
const openBlock = require("./components/common/open-block");
const options = require("./components/common/options");
const field = require("./components/common/field");
const fieldDropdown = require("./components/common/field-dropdown");
const checkbox = require("./components/common/checkbox");
const radio = require("./components/common/radio");
const anchors = require("./components/common/anchors");
const scrollbar = require("./components/common/scrollbar");
const closeConfirmaion = require("./components/common/close-confirmation.js");
const throttle = require("./components/common/throttle.js");
const stripe = require("./components/common/stripe.js");

const loginValidation = require("./components/auth/validation");
const checkoutValidation = require("./components/checkout/validation");

const information = require("./components/information");

const categoryTabs = require("./components/category/tabs");
const categoryFilters = require("./components/category/filters");
const categoryMap = require("./components/category/map");
const reviews = require("./components/product/reviews");
const book = require("./components/product/book");
const clearFilter = require("./components/category/clear-filter");
const filterField = require("./components/category/filter-field");

const productForm = require("./components/product/tickets-form");
const productMap = require("./components/product/map");

const checkoutCountDown = require("./components/checkout/countdown-timer");
const checkoutCard = require("./components/checkout/card");
const filterMore = require("./components/checkout/filter-more");
const promocode = require("./components/checkout/promocode");

const checkoutForm = require("./components/checkout/form");
const barRating = require("./components/product/bar-rating");
const cutDescription = require("./components/product/cut-description");

const globalSearch = require("./components/forms/search/search-autocomplete");
const searchPageFilters = require("./components/forms/search/filters");
const categoryPageFilters = require("./components/category/results-filter");

const iePositionSticky = require("./components/ie-polyfills/position-sticky");

const sharing = require("./components/product/share");
const details = require("./components/product/details");

$(() => {
  $.ajaxSetup({
    headers: {
      "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content")
    }
  });
});

$("div.alert")
  .not(".alert-important")
  .delay(30000)
  .fadeOut(350);

$(function() {
  $(window).on('resize', globalFunctions.resizeProductResultsImagesDebounced);
  globalFunctions.resizeProductResultsImages();

  $(window).on('resize', globalFunctions.resizeNearbyExperiencesImagesDebounced);
  globalFunctions.resizeNearbyExperiencesImages();
});

window.jQ = $;



// WEBPACK FOOTER //
// ./resources/assets/js/app.js